import React from 'react';
import getFileNameAndExtension from '@uppy/utils/lib/getFileNameAndExtension';
import toArray from '@uppy/utils/lib/toArray';

import { useUppyContext } from '@lyearn/shared/hooks/useUppy';

export const useHandleInputChange = (id: string) => {
  const uppy = useUppyContext();
  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = toArray(event.target.files);
    const descriptors = files.map((file: any) => {
      const { name, extension } = getFileNameAndExtension(file.name);

      const modifiedFile = new File([file], `${name}_${new Date().getTime()}.${extension}`, {
        type: file.type,
      });

      return {
        source: 'FileInput',
        name: file.name,
        type: modifiedFile.type,
        data: modifiedFile,
        meta: {
          relativePath: (file as any).relativePath,
          shortId: id,
        },
      };
    });

    try {
      uppy?.addFiles(descriptors);
    } catch (err) {
      console.log(err);
    }
    event.target.value = '';
  };

  return { handleInputChange };
};
